import { FC } from 'react'
import styled from 'styled-components'

type Props = {
  items?: number
}

export const EmptyPills: FC<Props> = ({ items = 3 }) => (
  <StyledEmptyWrapper>
    {new Array(items).fill({ item: '' })?.map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <StyledEmptyPill data-testid="empty-pill" key={index} />
    ))}
  </StyledEmptyWrapper>
)

const StyledEmptyPill = styled.div`
  height: 16px;
  width: 50px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.color.neutral.color8};
  margin-right: 40px;
`

const StyledEmptyWrapper = styled.div`
  display: flex;
  margin-top: 10px;
`
